import {
  CreateProductsPayload,
  EditSectionPayload,
  ProductsHidePayload,
  SortProductPayload,
  UpsertProductVariantPayload,
} from "app/types";
import {
  PredefinedVariantsListResponse,
  ProductVariantMutationResponse,
  ProductVariantsListResponse,
} from "app/types/productVariants";
import axios from "./config";

export const getProductsAPI = (storeId: number, query?: string) => {
  return axios.get(`/stores/${storeId}/products${query}`);
};

export const postProductsAPI = (
  storeId: number,
  payload: CreateProductsPayload
) => {
  return axios.post(`/stores/${storeId}/products`, payload);
};

export const putProductsAPI = (
  storeId: number,
  payload: CreateProductsPayload,
  productId: number
) => {
  return axios.put(`/stores/${storeId}/products/${productId}`, payload);
};

export const postProductSectionAPI = (payload: any) => {
  return axios.post(`/navigation-categories`, payload);
};

export const patchProductRecipeAPI = (
  storeId: number,
  productId: number,
  payload: { recipeId: number[] }
) => {
  return axios.patch(
    `/stores/${storeId}/products/${productId}/meal-products`,
    payload
  );
};

export const postSectionSortAPI = (payload: any) => {
  return axios.post(`/sort-navigation-categories`, payload);
};

export const patchProductStatusAPI = (
  storeId: number,
  productId: number,
  payload: ProductsHidePayload
) => {
  return axios.patch(
    `/stores/${storeId}/products/${productId}/status`,
    payload
  );
};

export const getProductStatusAPI = (storeId: number, productId: number) => {
  return axios.get(`/stores/${storeId}/products/${productId}/status`);
};

export const getSectionsAPI = () => {
  return axios.get(`/navigation-categories`);
};

export const getProductByIdAPI = (
  storeId: number | string,
  productId: number
) => {
  return axios.get(`/stores/${storeId}/products/${productId}`);
};

export const getSectionByIdAPI = (sectionId: number) => {
  return axios.get(`navigation-categories/${sectionId}`);
};

export const putSectionsAPI = (
  sectionId: number,
  payload: EditSectionPayload
) => {
  return axios.put(`/navigation-categories/${sectionId}`, payload);
};

export const sortProductAPI = (
  storeId: number,
  payload: SortProductPayload
) => {
  return axios.patch(`/stores/${storeId}/sort-products`, payload);
};

export const getPredefinedVariantsAPI = () => {
  return axios.get<PredefinedVariantsListResponse>(`/predefined-variants`);
};

export const getProductVariantsAPI = (storeId: number, productId: number) => {
  return axios.get<ProductVariantsListResponse>(
    `/stores/${storeId}/products/${productId}/variants`
  );
};

export const postProductVariantAPI = (
  storeId: number,
  productId: number,
  payload: UpsertProductVariantPayload
) => {
  return axios.post<ProductVariantMutationResponse>(
    `/stores/${storeId}/products/${productId}/variants`,
    payload
  );
};

export const putProductVariantAPI = (
  storeId: number,
  productId: number,
  variantId: number,
  payload: UpsertProductVariantPayload
) => {
  return axios.put<ProductVariantMutationResponse>(
    `/stores/${storeId}/products/${productId}/variants/${variantId}`,
    payload
  );
};
